import style from './Transcript.module.scss';
import TranscriptContentItem from './TranscriptContentItem';

export interface Conversation {
  id: number;
  speaker: string;
  words: string;
  metadata: {
    highlight: string[];
  };
}

export interface TranscriptContentProps {
  conversations: Conversation[];
}

const TranscriptContent = ({ conversations }: TranscriptContentProps) => {
  return (
    <div className={style.transcript__content__list}>
      {conversations?.map((conversation) => (
        <TranscriptContentItem
          key={conversation.id}
          conversation={conversation}
        />
      ))}
    </div>
  );
};

export default TranscriptContent;
